import React from 'react';

import styles from './CommunicationModule.module.scss';
import CommunicationModuleProvider from './CommunicationModuleProvider';
import CommunicationsMainLayout from './components/layouts/CommunicationsMainLayout';
import TemplateEditorPage from './components/pages/TemplateEditorPage';
import { EmailSettingsContextProvider } from './modules/emailTemplates/EmailSettingsContext';

export const CommunicationModule: React.FC<{}> = () => {
  return (
    <CommunicationModuleProvider>
      <CommunicationsMainLayout />
    </CommunicationModuleProvider>
  );
};

export const TemplateEditorModule: React.FC<{}> = () => {
  return (
    <CommunicationModuleProvider>
      <EmailSettingsContextProvider>
        <TemplateEditorPage className={styles.layout} />
      </EmailSettingsContextProvider>
    </CommunicationModuleProvider>
  );
};
